import { clsx } from 'clsx';

import type { UISizeVariant } from 'types/UserInterface';

import styles from './EmptyStateDataDisplay.module.css';

import { Icon } from 'components/Icon';

export interface EmptyStateDataDisplayProps {
  /** The main text to display. */
  label: string;
  /** The sub-text to display. */
  paragraph?: string;
  /** The colors of the wrapper and icon background are inverted. */
  invertColors?: boolean;
  /** The display variant. */
  variant?: UISizeVariant;
}

const ICON_SIZE_REGULAR = 24;
const ICON_SIZE_SLIM = 16;

/** Represents a component to indicate an empty state. */
export function EmptyStateDataDisplay({
  label,
  paragraph,
  invertColors,
  variant = 'regular',
}: EmptyStateDataDisplayProps) {
  return (
    <div
      className={clsx(styles['empty-state-data-display_wrapper'], {
        [styles['empty-state-data-display_wrapper--invert-colors']]: invertColors,
        [styles['empty-state-data-display_wrapper--slim']]: variant === 'slim',
      })}
    >
      <div
        className={clsx(styles['empty-state-data-display_icon-frame'], {
          [styles['empty-state-data-display_icon-frame--invert-colors']]: invertColors,
          [styles['empty-state-data-display_icon-frame--slim']]: variant === 'slim',
        })}
      >
        <Icon name="CubeTransparent" size={variant === 'regular' ? ICON_SIZE_REGULAR : ICON_SIZE_SLIM} />
      </div>
      <div className={styles['empty-state-data-display_text-content']}>
        <label className={styles['empty-state-data-display_label']}>{label}</label>
        {paragraph && <p className={styles['empty-state-data-display_paragraph']}>{paragraph}</p>}
      </div>
    </div>
  );
}
